import { action } from '@ember/object';
import Component from '@glimmer/component';

import FormCheckboxSwitchComponent from 'webapp/components/form/checkbox-switch';

import type Block from 'webapp/models-custom/block';

interface Args {
	blockM: Block;
}

export default class BlockSettingsTableColumnInvertComponent extends Component<Args> {
	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup() {
		return this.block.blockSetup;
	}

	get selected(): boolean {
		return this.block.tableColumnInvert;
	}

	@action
	changeSelected(selected: boolean): void {
		this.block.tableColumnInvert = selected;
		this.blockSetup.saveBlock();
	}

	<template>
		<div class="row row--toggle">
			<FormCheckboxSwitchComponent
				@name="tableColumnInvert"
				@selected={{this.selected}}
				@onChange={{this.changeSelected}}
			/>
			<label>Show recent dates first</label>
		</div>
	</template>
}
